import React from 'react';
import { type DocumentElement as DocumentElementType } from '@eaco/forms-core';
import DocumentElement from '../DocumentView/DocumentElement';

interface Props {
  element: DocumentElementType;
}

const Page: React.FC<Props> = ({ element }) => {
  const children = element.elements || [];

  if (children.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-muted-foreground/25 p-6 text-center">
        <p className="text-sm text-muted-foreground italic">
          No elements on this page
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {children.map((child) => (
        <DocumentElement key={child.id} element={child} />
      ))}
    </div>
  );
};

export default Page;
